import type { ValueScale } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/AreaChart/types";
import { FC } from "react";
import { Text } from "shared/components/Spor";
import { useTheme } from "styled-components";

interface YAxisLabelsProps {
  valueScale: ValueScale;
  desiredTickCount: number;
}

export const YAxisLabels: FC<YAxisLabelsProps> = ({
  valueScale,
  desiredTickCount,
}) => {
  const theme = useTheme();

  const ticks = valueScale ? valueScale.ticks(desiredTickCount) : [];

  const LABEL_WIDTH = 36; // px
  const LABEL_HEIGHT = 10; // px
  return (
    <>
      {ticks.map((tick) =>
        tick !== 0 ? (
          <foreignObject
            key={tick}
            y={valueScale(tick) - LABEL_HEIGHT / 2}
            width={LABEL_WIDTH}
            height={LABEL_HEIGHT}
            style={{ overflow: "visible" }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                width: "100%",
                height: "100%",
              }}
            >
              <Text fontSize="2xs" color={theme.colorTextSecondary} ml={3}>
                {tick}
              </Text>
            </div>
          </foreignObject>
        ) : null,
      )}
    </>
  );
};
